import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  UrlTree,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { PaymentCodeService } from '../services/payment-code.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentCodeGuard implements CanActivate {
  constructor(
    private paymentCodeService: PaymentCodeService,
    private router: Router
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const hasCode = await this.paymentCodeService.processQueryParams(
      route.queryParams
    );

    if (hasCode) {
      const pathWithoutQuery = state.url.split('?')[0];

      console.log(
        'PaymentCodeGuard: redirecting to',
        pathWithoutQuery,
        'after processing payment code'
      );
      return this.router.createUrlTree([pathWithoutQuery], {
        queryParams: {},
        preserveFragment: true,
      });
    }

    return true;
  }
}
